import Cookies from 'js-cookie'
import { sumBy } from 'lodash'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import * as uuid from 'uuid'
import { default as config, default as configs } from '../../config'
import { ORDER_ITEM_TYPE, getOrderItemType } from '../../constants/item'
import { BAD_SLIP_SCAN_ERROR_MSG, DEFAULT_ERROR_MSG, SLIP_APPROVE_ERROR_MSG } from '../../constants/order/error/const'
import { checkCouponType } from '../../helpers/couponApi'
import { formatPrice } from '../../helpers/utils'
import { PAYMENT_STATUS } from '../Payment/constants'
import OrderActionBox from './OrderActionBox'
import OrderCancelReasonBox from './OrderCancelReasonBox'
import OrderDetailInvoice from './OrderDetailInvoice'
import OrderItemsDataTable from './OrderItemsDataTable'
import OrderNoteList from './OrderNoteList'
import OrderStatusBox from './OrderStatusBox'
import OrderUserList from './OrderUserList'
import Colors from '../../constants/Colors'

const SLIP_CAT = {
  LOTTO: 'LOTTERY',
  SLOT: 'SLOT',
}

const UNASSIGNED_TIME = '0001-01-01T00:00:00Z'

export default function OrderDetail({
  order,
  fetchOrderDetail,
  fetchOrders,
  setFullpage,
  setOrderDetail,
  handleBlockOrder,
  setOrderIdSelected,
  setOrderSelectedAfter,
  unlockOrder,
}) {
  const createDate = new Date(order.createdAt).toLocaleString('TH-th')
  const approveDate = new Date(order.approvedAt).toLocaleString('TH-th')
  const sendDate = order?.gift?.sentAt ? new Date(order?.gift?.sentAt).toLocaleString('TH-th') : null
  const cancelDate = order.canceledAt && new Date(order.canceledAt).toLocaleString('TH-th')
  const [isShowLineChat, setIsShowLineChat] = useState(false)
  const [orderStatus, setOrderStatus] = useState(null)
  const [isForceCancel, setIsForceCancel] = useState(false)
  const [cancelReason, setCancelReason] = useState(null)
  const [enableStatus, setEnableStatus] = useState(false)
  const [orderOther, setOrderOther] = useState([])
  const [moreEvidencesSlip, setMoreEvidencesSlip] = useState([])
  const [actionBadSlip, setactionBadSlip] = useState(false)
  const [noteText, setNoteText] = useState('')
  const couponType = checkCouponType(order.couponId)
  const orderType = getOrderItemType(order?.items[0].type)
  const adminId = useSelector((state) => state.admin.id)

  const dispatch = useDispatch()

  useEffect(() => {
    setOrderStatus(order.status)
    fetchOrderByUser(order.user.userNo)
    fetchMoreEvidencesSlip(order.paymentId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleOnChangeMoneyAmount = (event) => {
    const element = document.getElementById(event.target.id)
    if (element && /^[0-9]+(\.{1}[0-9]{0,2})?$/.test(event.target.value)) {
      element.value = event.target.value
    } else {
      element.value = event.target.value.slice(0, -1)
    }
  }

  const handleOnChangeSlipRef = (event) => {
    const element = document.getElementById(event.target.id)
    if (element && /^[0-9a-z]+$/i.test(event.target.value)) {
      element.value = event.target.value
    } else {
      element.value = event.target.value.slice(0, -1)
    }
  }

  const fetchOrderByUser = async (userNo) => {
    try {
      const requestUrl = `${configs.apiAdminGateway}/api/v3/admin/orders?userNo=${userNo}&page=1&limit=200`
      const getAccessToken = Cookies.get('accessToken')
      const myHeaders = new Headers()
      myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
      myHeaders.append('Content-Type', 'application/json')
      fetch(requestUrl, { method: 'GET', headers: myHeaders })
        .then((response) => response.json())
        .then(async (result) => {
          setOrderOther(result.data)
        })
    } catch (err) {
      console.error(err)
    }
  }

  function recordNote(orderNo, noteText, userNo, paymentId) {
    Swal.fire({
      title: `กรุณายืนยันการบันทึกโน๊ตของหมายเลขคำสั่งซื้อ ${orderNo}`,
      text: `ข้อความที่บันทึก : ${noteText} `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: Colors.SOFT_BLUE,
      cancelButtonColor: Colors.LIGHT_RED,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (!result.isConfirmed) return

      dispatch({ type: 'loading_show' })
      const myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')
      myHeaders.append('Authorization', `Bearer ${Cookies.get('accessToken')}`)
      const response = await fetch(`${configs.apiAdminGateway}/api/v2/admin/payments/${paymentId}/note`, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({
          text: noteText,
        }),
      }).then((response) => response.json())

      if (response.status.code === 0) {
        dispatch({ type: 'loading_hide' })
        Swal.fire({
          icon: 'success',
          title: 'บันทึกโน๊ตสำเร็จ',
          showConfirmButton: false,
          timer: 3000,
        })
        setOrderStatus(order.status)
        await fetchOrderByUser(userNo)
        await fetchOrderDetail(order)
        await fetchMoreEvidencesSlip(paymentId)
      } else {
        dispatch({ type: 'loading_hide' })
        Swal.fire({
          icon: 'warning',
          title: 'พบข้อผิดพลาด ไม่สามารถบันทึกโน๊ตได้ในขณะนี้',
        })
      }
    })
  }

  const returnGift = (orderId, orderNo) => {
    Swal.fire({
      title: `กรุณายืนยันการคืนของขวัญของหมายเลขคำสั่งซื้อ ${orderNo}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: Colors.SOFT_BLUE,
      cancelButtonColor: Colors.LIGHT_RED,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch({ type: 'loading_show' })
        try {
          const myHeaders = new Headers()
          myHeaders.append('Content-Type', 'application/json')
          myHeaders.append('Authorization', `Bearer ${Cookies.get('accessToken')}`)
          const response = await fetch(`${configs.apiAdminGateway}/api/v3/admin/orders/${orderId}/gifts/return`, {
            method: 'POST',
            headers: myHeaders,
          }).then((response) => response.json())

          if (response.status.code !== 0) throw new Error(response.status.description)

          dispatch({ type: 'loading_hide' })
          Swal.fire({
            icon: 'success',
            title: 'คืนของขวัญสำเร็จ',
            showConfirmButton: false,
          })
        } catch (error) {
          Swal.fire({
            icon: 'warning',
            title: 'พบข้อผิดพลาด ไม่สามารถคืนของขวัญได้ในขณะนี้',
            text: error.message,
          })
        } finally {
          dispatch({ type: 'loading_hide' })
          await fetchOrderDetail(order)
        }
      }
    })
  }

  const generateGiftToken = (orderId, orderNo) => {
    Swal.fire({
      title: `กรุณายืนยันการสร้างโทเค็นของขวัญของหมายเลขคำสั่งซื้อ ${orderNo}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: Colors.SOFT_BLUE,
      cancelButtonColor: Colors.LIGHT_RED,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (!result.isConfirmed) return

      dispatch({ type: 'loading_show' })
      try {
        const headers = new Headers()
        headers.append('Content-Type', 'application/json')
        headers.append('Authorization', `Bearer ${Cookies.get('accessToken')}`)

        const response = await fetch(`${configs.apiAdminGateway}/api/v3/admin/orders/generateGiftToken`, {
          method: 'POST',
          headers,
          body: JSON.stringify({
            orderId,
          }),
        }).then((response) => response.json())

        if (response.status.code !== 0) throw new Error(response.status.description)

        Swal.fire({
          icon: 'success',
          title: 'สร้างโทเค็นของขวัญสำเร็จ',
          showConfirmButton: false,
        })
      } catch (error) {
        Swal.fire({
          icon: 'warning',
          title: 'พบข้อผิดพลาด ไม่สามารถสร้างโทเค็นของขวัญได้ในขณะนี้',
          text: error.message,
        })
      } finally {
        dispatch({ type: 'loading_hide' })
        await fetchOrderDetail(order)
      }
    })
  }

  async function tickerLineNotify(lineId, templateName, orderNo, remainingAmount, transactionId) {
    const raw = JSON.stringify({
      lineUid: lineId,
      refNo: orderNo,
      remainingAmount,
      templateName,
      transactionId,
      category: SLIP_CAT.LOTTO,
    })
    let textNotify = ''
    if (templateName === 'SLIP-INCORRECT') {
      textNotify = `หมายเลขคำสั่งซื้อที่ ${orderNo} ราคา ${remainingAmount} บาท พบสลิปไม่ถูกต้อง `
    } else if (templateName === 'INCOMPLETE-PAYMENT') {
      textNotify = `หมายเลขคำสั่งซื้อที่ ${orderNo} แจ้งเตือนยอดค้างชำระ ${remainingAmount} บาท  `
    }
    Swal.fire({
      title: 'กรุณายืนยันการส่ง Line แจ้งเตือนลูกค้า',
      text: textNotify,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: Colors.SOFT_BLUE,
      cancelButtonColor: Colors.LIGHT_RED,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch({ type: 'loading_show' })
        const myHeaders = new Headers()
        const getAccessToken = Cookies.get('accessToken')
        myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
        myHeaders.append('Content-Type', 'application/json')
        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
        }
        const respond = await fetch(`${configs.apiAdminGateway}/api/v1/admin/badqr/notification`, requestOptions)
        const statusCode = respond.status
        const toJson = await respond.json()
        if (statusCode === 200) {
          Swal.fire({
            icon: 'success',
            title: 'ส่งการแจ้งเตือนทาง Line ไปยังลูกค้าสำเร็จ',
            showConfirmButton: false,
            timer: 3000,
          })
          setOrderStatus(order.status)
          fetchOrderByUser(order.user.userNo)
          fetchMoreEvidencesSlip(order.paymentId)
          dispatch({ type: 'loading_hide' })
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'พบข้อผิดพลาด',
            text: toJson.msg,
          })
          dispatch({ type: 'loading_hide' })
        }
      }
    })
  }

  async function readQRCodeThisSlip(imageUrl, popId, qrText = '') {
    Swal.fire({
      title: 'ยิงเครื่องสแกน QR Code ที่สลิป',
      text: 'เพื่อดำเนินการตรวจสอบจากเครื่องยิง',
      imageUrl: imageUrl,
      imageAlt: 'Custom image',
      showConfirmButton: false,
      confirmButtonText: 'ส่งข้อมูลให้ระบบตรวจใหม่',
      confirmButtonColor: Colors.SOFT_BLUE,
      input: 'text',
      inputValue: qrText,
      inputAttributes: {
        autocapitalize: 'on',
      },
      preConfirm: async (qrcode) => {
        dispatch({ type: 'loading_show' })
        // preparing data
        const raw = JSON.stringify({
          qrText: qrcode,
        })
        const myHeaders = new Headers()
        const getAccessToken = Cookies.get('accessToken')
        myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
        myHeaders.append('Content-Type', 'application/json')
        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
        }
        const respond = await fetch(`${configs.apiAdminGateway}/api/v2/admin/pop/${popId}/recheck`, requestOptions)
        const statusCode = respond.status
        const toJson = await respond.json()
        if (statusCode === 200) {
          if (toJson.code === 0) {
            dispatch({ type: 'loading_hide' })
            Swal.fire({
              icon: 'success',
              title: 'ตรวจ QR Code สำเร็จ',
              showConfirmButton: true,
              confirmButtonColor: Colors.SOFT_BLUE,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchOrderDetail(order)
                setOrderStatus(order.status)
                fetchOrderByUser(order.user.userNo)
                fetchMoreEvidencesSlip(order.paymentId)
              }
            })
          } else if (toJson.code === 1002) {
            dispatch({ type: 'loading_hide' })
            Swal.fire({
              icon: 'error',
              title: 'Failed to approve slip  !!',
              text: toJson.desc,
              showConfirmButton: true,
            })
          } else {
            dispatch({ type: 'loading_hide' })
            Swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: toJson.desc,
              showConfirmButton: true,
              confirmButtonColor: Colors.SOFT_BLUE,
            }).then((result) => {
              if (result.isConfirmed) {
                setOrderStatus(order.status)
                fetchOrderByUser(order.user.userNo)
                fetchMoreEvidencesSlip(order.paymentId)
              }
            })
          }
        } else {
          dispatch({ type: 'loading_hide' })
          Swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: BAD_SLIP_SCAN_ERROR_MSG[toJson.code.toString()] || DEFAULT_ERROR_MSG,
            showConfirmButton: true,
            confirmButtonColor: Colors.SOFT_BLUE,
          }).then((result) => {
            if (result.isConfirmed) {
              setOrderStatus(order.status)
              fetchOrderByUser(order.user.userNo)
              fetchMoreEvidencesSlip(order.paymentId)
            }
          })
        }
      },
    })
  }
  async function rejectBadSlip(popId) {
    Swal.fire({
      title: 'กรุณายืนยันการเปลี่ยนสถานะ Bad Slip ไปเป็น Reject Slip',
      text: 'เมื่อคุณยืนยันแล้วระบบจะไม่สามารถย้อนกลับได้นะ',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: Colors.SOFT_BLUE,
      cancelButtonColor: Colors.LIGHT_RED,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch({ type: 'loading_show' })
        const raw = JSON.stringify({})
        const myHeaders = new Headers()
        const getAccessToken = Cookies.get('accessToken')
        myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
        myHeaders.append('Content-Type', 'application/json')
        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
        }
        const respond = await fetch(`${configs.apiAdminGateway}/api/v2/admin/pop/${popId}/reject`, requestOptions)
        const statusCode = respond.status
        const toJson = await respond.json()
        if (statusCode === 200) {
          if (toJson.code === 0) {
            dispatch({ type: 'loading_hide' })
            Swal.fire({
              icon: 'success',
              title: 'Reject Slip Success !!',
              text: `Admin ยืนยันว่าเป็น Bad Slip จริง สำเร็จ`,
              showConfirmButton: true,
            })
          } else {
            dispatch({ type: 'loading_hide' })
            Swal.fire({
              icon: 'warning',
              title: 'Approve Slip warning !!',
              text: `ข้อมูลไม่ถูกต้อง ${toJson.desc}`,
              showConfirmButton: true,
            })
          }
        } else {
          dispatch({ type: 'loading_hide' })
          Swal.fire({
            icon: 'warning',
            title: 'Approve Slip warning !!',
            text: `ข้อมูลไม่ถูกต้อง ${toJson.msg}`,
            showConfirmButton: true,
          })
        }
        setactionBadSlip(false)
        setOrderStatus(order.status)
        await fetchOrderByUser(order.user.userNo)
        await fetchOrderDetail(order)
        await fetchMoreEvidencesSlip(order.paymentId)
      }
    })
  }
  const approveBadSlip = async (popId, index, lineUid, orderRefNo, orderId) => {
    let eleAmoutAdminReadSlip = 'amoutAdminReadSlip'
    let elerefNoAdminReadSlip = 'refNoAdminReadSlip'
    if (index > -1 && index !== null) {
      eleAmoutAdminReadSlip = `amoutAdminReadSlip-${index}`
      elerefNoAdminReadSlip = `refNoAdminReadSlip-${index}`
    }
    const getamount = document.getElementById(eleAmoutAdminReadSlip).value
    const getRefNoOrder = document.getElementById(elerefNoAdminReadSlip).value
    if (getRefNoOrder === '') {
      document.getElementById(elerefNoAdminReadSlip).focus()
    } else if (getamount === '') {
      document.getElementById(eleAmoutAdminReadSlip).focus()
    } else {
      Swal.fire({
        title: 'กรุณายืนยันการอนุมัติ Bad Slip ไปเป็น Approve ',
        text: `เมื่อคุณยืนยันระบบจะอัปเดตยอดที่คุณอ่านได้ ยอด ${getamount} บาท เข้าไปกับคำสั่งซื้อนี้ และจะไม่สามารถย้อนกลับได้นะ`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: Colors.SOFT_BLUE,
        cancelButtonColor: Colors.LIGHT_RED,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      }).then(async (result) => {
        if (result.isConfirmed) {
          dispatch({ type: 'loading_show' })
          const raw = JSON.stringify({
            tranRef: getRefNoOrder,
            amount: parseInt(getamount).toString(),
          })
          const myHeaders = new Headers()
          const getAccessToken = Cookies.get('accessToken')
          myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
          myHeaders.append('Content-Type', 'application/json')
          const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
          }
          const respond = await fetch(`${configs.apiAdminGateway}/api/v2/admin/pop/${popId}/approve`, requestOptions)
          const statusCode = respond.status
          const toJson = await respond.json()
          if (statusCode === 200) {
            if (toJson.code === 0) {
              dispatch({ type: 'loading_hide' })
              Swal.fire({
                icon: 'success',
                title: 'Approve Slip Success !!',
                text: `Admin อนุมัติสลิปยอด ${getamount} บาท สำเร็จ`,
                showConfirmButton: true,
              })
            } else if (toJson.code === 1002) {
              dispatch({ type: 'loading_hide' })
              Swal.fire({
                icon: 'error',
                title: 'Failed to approve slip  !!',
                text: toJson.desc,
                showConfirmButton: true,
              })
            } else {
              dispatch({ type: 'loading_hide' })
              const text = SLIP_APPROVE_ERROR_MSG[toJson.code.toString()] || DEFAULT_ERROR_MSG
              Swal.fire({
                icon: 'error',
                title: 'Failed to approve slip  !!',
                text: text,
                showConfirmButton: true,
              })
            }
          } else {
            dispatch({ type: 'loading_hide' })
            const text = SLIP_APPROVE_ERROR_MSG[toJson.code.toString()] || DEFAULT_ERROR_MSG
            Swal.fire({
              icon: 'error',
              title: 'Failed to approve slip  !!',
              text: text,
              showConfirmButton: true,
            })
          }
          setactionBadSlip(false)
          setOrderStatus(order.status)
          await fetchOrderDetail(order)
          await fetchMoreEvidencesSlip(order.paymentId)
          await fetchOrderByUser(order.user.userNo)
        }
      })
    }
  }

  // New function
  const fetchMoreEvidencesSlip = async (paymentId) => {
    if (!paymentId) return

    try {
      const requestUrl = `${configs.apiAdminGateway}/api/v2/admin/payments/${paymentId}/pop`
      const response = await fetch(requestUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((response) => response.json())

      if (response.status.code !== 0) throw new Error(response.description)

      const proofOfPayments = response.data
      const paidAmount = sumBy(proofOfPayments, (pop) => Number(pop.amount))

      setOrderDetail((order) => ({ ...order, paidAmount, evidence: proofOfPayments.slice(0, 1) || [] }))

      if (proofOfPayments.length > 1) {
        setMoreEvidencesSlip(proofOfPayments.slice(1))
      }
    } catch (error) {
      console.error(error)
    }
  }

  async function cancelOrder() {
    dispatch({ type: 'loading_show' })
    try {
      const response = await fetch(`${configs.apiAdminGateway}/api/v2/admin/payments/${order.paymentId}/cancel`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
        body: JSON.stringify({
          reason: cancelReason,
        }),
      })
      const json = await response.json()

      if (json.code !== 0) throw new Error(json.description)

      Swal.fire({
        icon: 'success',
        title: 'ยกเลิกคำสั่งซื้อสำเร็จ !!',
        showConfirmButton: true,
      }).then(() => {
        setOrderIdSelected((lockedOrders) => {
          const lockedOrdersFilter = lockedOrders.filter((item) => item.id !== order.id)
          return [...lockedOrdersFilter]
        })
        unlockOrder(order.id)
        setOrderSelectedAfter(null)
        fetchOrders()
      })
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'พบข้อผิดพลาด !!',
        text: error.message,
        showConfirmButton: true,
      })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const handleChangeOrder = async (e) => {
    e.preventDefault()
    if (orderStatus === 'CANCEL' && !cancelReason) {
      alert('โปรดเลือกเหตุผลที่ยกเลิก เพื่อส่งบอกลูกค้า')
      return
    }
    switch (orderStatus) {
      case 'CANCEL':
        await cancelOrder().catch(() => alert('เกิดข้อผิดพลาด'))
        break
      default:
        break
    }
    setOrderDetail(null)
    setFullpage(false)
  }

  function handleForceCancel() {
    setEnableStatus(true)
    setIsForceCancel(true)
  }

  function handleCancelReason(value) {
    setCancelReason(value)
  }

  function handleOnClickSendLineMessage(userId) {
    const elLineMessage = document.querySelector('#line_message')
    if (userId) {
      fetch(`${config.apiAdminGateway}/api/v2/admin/notification/line`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
        body: JSON.stringify({
          userId: userId,
          message: elLineMessage.value,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.status.code !== 0) throw new Error(res.status.description)

          Swal.fire({
            icon: 'success',
            title: 'ส่งข้อความสำเร็จ',
            showConfirmButton: true,
          })
        })
        .catch((err) => {
          Swal.fire({
            icon: 'error',
            title: 'ส่งข้อความไม่สำเร็จ',
            text: err.message,
            showConfirmButton: true,
          })
        })
    }

    setIsShowLineChat(false)
  }
  function checkTimeOutProcessBadSlips(then, timeUp = 15) {
    const now = new Date()
    const current = moment(now, 'DD/MM/YYYY HH:mm:ss')
    const timeOut = moment(then, 'DD/MM/YYYY HH:mm:ss').add(timeUp, 'minutes')
    return current.isAfter(timeOut)
  }

  const bankNameDisplay = (bankName) => {
    switch (bankName) {
      case 'LHFG':
        return 'LH'
      default:
        return bankName
    }
  }

  return (
    <>
      <Modal show={isShowLineChat} onHide={() => setIsShowLineChat(false)} centered>
        <Modal.Header>ทักแชทไลน์</Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Label>
              ชื่อลูกค้า :{' '}
              {order && order.user && order.user.firstName
                ? `${order.user.firstName} ${order.user.lastName || ''} (${order.user.lineName})`
                : order.name}
            </Form.Label>
            <Form.Control
              as="textarea"
              id="line_message"
              rows={3}
              className="mt-2"
              placeholder="ข้อความที่ต้องการส่ง"
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={() => setIsShowLineChat(false)}>
            ยกเลิก
          </Button>
          <Button variant="primary light" onClick={() => handleOnClickSendLineMessage(order.user.userId)}>
            ส่งข้อความ
          </Button>
        </Modal.Footer>
      </Modal>
      <Card className="p-4" style={{ maxHeight: 'calc(100% - 100px)' }}>
        <Card.Header>
          <Card.Title>คำสั่งซื้อ #{order.orderNo}</Card.Title>
          {orderType === ORDER_ITEM_TYPE.BOX && (
            <span
              style={{
                fontSize: '20px',
                fontWeight: '500',
              }}
              className="text-danger"
            >
              (กล่องสุ่ม)
            </span>
          )}
          {(order.status === 'SUCCESS' || order.status === 'CANCEL') && <OrderDetailInvoice order={order} />}
          {orderStatus === 'CONFIRMED' && order.action.action !== 'BLOCKED' && (
            <div className="btn btn-sm btn-outline-dark" onClick={() => handleBlockOrder(order)}>
              มีปัญหา
            </div>
          )}
        </Card.Header>
        <Card.Body>
          <div className="d-flex position-relative w-100 h-100 p-5" style={{ overflow: 'scroll' }}>
            <div
              className="d-flex flex-column position-absolute"
              style={{
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                marginRight: '15px',
              }}
            >
              <Row>
                <Col>
                  <div className="border-bottom mb-2">
                    <h4>ข้อมูลลูกค้า</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="d-flex">
                    <ul className="w-100">
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>{`${order.user.firstName || '-'} ${order.user.lastName || '-'}`}</div>
                          <div>{order.user.userNo}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>{order.user.phoneNo || ''}</div>
                          <div>
                            <span className="mr-1">{order.user.lineName}</span>(
                            <span
                              className="text-success"
                              style={{ cursor: 'pointer' }}
                              onClick={() => setIsShowLineChat(true)}
                            >
                              เปิดแชทไลน์
                            </span>
                            )
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>บัญชีที่เงินเข้า</div>
                          <div>-</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>บัญชีลูกค้า</div>
                          <div>{`ธ. ${bankNameDisplay(order?.user?.bankName)} ${order.user?.bankNo}`}</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2">
                    <h4>ข้อมูลการส่งของขวัญ</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="d-flex">
                    <ul className="w-100">
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>วันที่ส่ง</div>
                          <div>{sendDate || '-'}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>ผู้รับ</div>
                          <div>{order?.gift?.name || '-'}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>User ID ผู้รับ</div>
                          <div>{order?.gift?.receiverId || '-'}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>ข้อความ</div>
                          <div style={{ width: '80%', textAlign: 'end' }}>{order?.gift?.message || '-'}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <h4>ของขวัญ</h4>
                          <div style={{ width: '80%', textAlign: 'end' }}>
                            {order?.status !== 'SUCCESS' || order?.isDelivery ? (
                              '-'
                            ) : (
                              <Fragment>
                                {order?.gift?.receiverId ? (
                                  <button
                                    className="btn btn-success "
                                    style={{ padding: '5px 15px' }}
                                    onClick={() => returnGift(order.id, order.orderNo)}
                                  >
                                    คลิกเพื่อคืนของขวัญ
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-primary"
                                    style={{ padding: '5px 15px' }}
                                    onClick={() =>
                                      order?.gift?.token
                                        ? navigator.clipboard.writeText(order?.gift?.token)
                                        : generateGiftToken(order.id, order.orderNo)
                                    }
                                  >
                                    {order?.gift?.token || 'คลิกเพื่อสร้างโทเค็นของขวัญ'}
                                  </button>
                                )}
                              </Fragment>
                            )}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2">
                    <h4>ข้อมูลการสั่งซื้อ</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="d-flex">
                    <ul className="w-100">
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>วันที่ซื้อ</div>
                          <div>{createDate}</div>
                        </div>
                      </li>
                      <li>
                        {orderStatus === 'SUCCESS' && (
                          <div
                            className="d-flex justify-content-between align-items-center"
                            style={{ marginBottom: '8px' }}
                          >
                            <div>วันที่ยืนยันคำสั่งซื้อ</div>
                            <div>{order.approvedAt !== null ? approveDate : '-'}</div>
                          </div>
                        )}
                        {orderStatus === 'CANCEL' && (
                          <div
                            className="d-flex justify-content-between align-items-center"
                            style={{ marginBottom: '8px' }}
                          >
                            <div>วันที่ยกเลิกคำสั่งซื้อ</div>
                            <div>{cancelDate}</div>
                          </div>
                        )}
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>จำนวนลอตเตอรี่</div>
                          <h3>{`${formatPrice(order.totalItem)} ใบ`}</h3>
                        </div>
                      </li>
                      {couponType === '-' && (
                        <Fragment>
                          <li>
                            <div
                              className="d-flex justify-content-between align-items-center"
                              style={{ marginBottom: '8px' }}
                            >
                              <div>ค่าลอตเตอรี่</div>
                              <h3>{`${formatPrice(order.price)} บาท`}</h3>
                            </div>
                          </li>
                          <li>
                            <div
                              className="d-flex justify-content-between align-items-center"
                              style={{ marginBottom: '8px' }}
                            >
                              <div>{order.isDelivery ? 'ค่าจัดส่ง' : 'ค่าเช่าพื้นที่จัดเก็บ'}</div>
                              <h3>{`${formatPrice(order.fee)} บาท`}</h3>
                            </div>
                          </li>
                          <li>
                            <div
                              className="d-flex justify-content-between align-items-center"
                              style={{ marginBottom: '8px' }}
                            >
                              <span>นกพอยต์ที่ได้รับ</span>
                              <h3>{`${formatPrice(order?.point?.amount || 0)} พอยต์`}</h3>
                            </div>
                          </li>
                        </Fragment>
                      )}
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>ยอดรวม</div>
                          <h3 style={{ color: 'red' }}>{`${formatPrice(order.totalPrice)} บาท`}</h3>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-3 mb-2">
                    <h4>รายการตรวจสอบ</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="d-flex w-100">
                    <ul className="d-flex flex-column w-100">
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>Slip Reference Number</div>
                          <div>{order.transRef || order.tempTransRef || ''}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div className="d-flex" style={{ width: '210px', minWidth: '210px' }}>
                            สถานะตรวจสอบสลิปอัตโนมัติ (ล่าสุด)
                          </div>
                          <div style={{ fontSize: '14px' }}>{order.evidence?.[0]?.status}</div>
                        </div>
                      </li>
                      {adminId === order.action.adminId && (
                        <li className="d-flex">
                          <OrderStatusBox
                            order={order}
                            newStatus={orderStatus}
                            enableOrderStatus={enableStatus}
                            onChange={(value) => setOrderStatus(value)}
                          />
                        </li>
                      )}
                      {order.status === 'CANCEL' && (
                        <li>
                          <div
                            className="d-flex w-100 align-items-center justify-content-between mb-2"
                            style={{ height: '40px' }}
                          >
                            <label className="d-flex mb-0" style={{ width: '210px', minWidth: '210px' }}>
                              เหตุผลในการยกเลิก :
                            </label>
                            {order.canceledReason}
                          </div>
                        </li>
                      )}
                      {order.status !== 'CANCEL' && orderStatus === 'CANCEL' && (
                        <li>
                          <OrderCancelReasonBox order={order} onChange={(value) => handleCancelReason(value)} />
                        </li>
                      )}
                    </ul>
                  </div>
                  <li>
                    <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '8px' }}>
                      <div>ยอดรวม</div>
                      <h3 style={{ color: 'red' }}>{`${formatPrice(order.totalPrice)} บาท`}</h3>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '0px' }}>
                      <div>ชำระมาแล้ว</div>
                      <h3 style={{ color: 'red' }}>
                        {order.status === 'OPEN' ? <>0 บาท</> : <>{formatPrice(order.paidAmount)} บาท</>}
                      </h3>
                    </div>
                  </li>
                  <li>
                    {order.remainingAmount < 0 ? (
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ marginBottom: '8px' }}
                      >
                        <div>ชำระมาเกิน</div>
                        <h3 style={{ color: 'red' }}>{`${formatPrice(order.remainingAmount * -1)} บาท`}</h3>
                      </div>
                    ) : (
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ marginBottom: '8px' }}
                      >
                        <div>ค้างชำระ</div>
                        <h3 style={{ color: 'red' }}>{`${formatPrice(parseInt(order.remainingAmount))} บาท`}</h3>
                      </div>
                    )}
                  </li>
                  <li>
                    <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '0px' }}>
                      <div>โน๊ต: </div>
                      <input
                        className="form-control form-control-sm"
                        id="noteOfOrders"
                        value={noteText || ''}
                        onChange={(e) => setNoteText(e.target.value)}
                        style={{
                          marginRight: '20px',
                          marginLeft: '20px',
                          padding: '5px 8px',
                          height: '40px',
                          color: '#000',
                        }}
                      />
                      <button
                        className="btn btn-success "
                        style={{ padding: '5px 15px' }}
                        onClick={() => recordNote(order.orderNo, noteText, order.user.userNo, order.paymentId)}
                      >
                        บันทึก
                      </button>
                    </div>
                  </li>
                  {order?.notes && <OrderNoteList notes={order.notes} />}
                  <li>
                    <div className="d-flex justify-content-center align-items-center" style={{ marginTop: '16px' }}>
                      <OrderActionBox
                        order={order}
                        isForceCancel={isForceCancel}
                        onOk={(e) => handleChangeOrder(e)}
                        onForceCancel={(e) => handleForceCancel(e)}
                        unlockOrder={unlockOrder}
                      />
                    </div>
                  </li>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2">
                    <h3>หลักฐานการโอนเงิน</h3>
                  </div>
                </Col>
              </Row>
              <Row>
                {order.evidence?.length > 0 ? (
                  <Col>
                    <div className="row">
                      <div
                        className="col-5"
                        style={{
                          justifyContent: 'center',
                          display: 'flex',
                        }}
                      >
                        {order.evidence[0].imageURL !== '' ? (
                          <>
                            <img
                              src={`${order.evidence[0].imageURL}`}
                              style={{
                                maxWidth: '360px',
                                maxHeight: '600px',
                              }}
                              alt="slip"
                            />
                          </>
                        ) : (
                          'ไม่พบสลิป'
                        )}
                      </div>
                      <div className="col-7">
                        <h4>สถานะระบบตรวจสอบสลิปอัตโนมัติ </h4>
                        {order.evidence?.length === 0 ? (
                          <>
                            {/* เคสที่ระยะเวลาการประมวลผลมากกว่า 15 นาทีจะมีปุ่มให้ตรวจสอบสลิปโดยตรงขึ้นมา */}
                            {order.status === 'CONFIRMED' ? (
                              <>
                                <hr />
                                {checkTimeOutProcessBadSlips(new Date(order.evidence[0].createdAt)) ? (
                                  <>
                                    <p>
                                      <b className="text-danger">สถานะ: กำลังประมวลผล </b>
                                    </p>
                                    <p>
                                      <b>อัปโหลดเมื่อเวลา</b>:{' '}
                                      {new Date(order.evidence[0].createdAt).toLocaleString('TH-th')} น.
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <p>
                                      <b className="text-danger">
                                        สถานะ: ระบบกำลังดำเนินการตรวจสอบสลิป ใช้เวลาประมาณ 5-15 นาที{' '}
                                      </b>
                                    </p>
                                    <p>
                                      <b>อัปโหลดเมื่อเวลา</b>:{' '}
                                      {new Date(order.evidence[0].createdAt).toLocaleString('TH-th')} น.
                                    </p>
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {order.status === 'CANCEL' || order.status === 'SUCCESS' ? (
                                  <>
                                    <p className="text-info">
                                      สถานะ: ระบบได้เคลียร์สลิปออกจาก Queue
                                      แล้วเนื่องจากการดำเนินการของคำสั่งซื้อนี้สิ้นสุดแล้ว
                                    </p>
                                    <p>
                                      <b>อัปโหลดเมื่อเวลา</b>:{' '}
                                      {new Date(order.evidence[0].createdAt).toLocaleString('TH-th')} น.
                                    </p>
                                  </>
                                ) : null}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <hr />
                            <p>
                              <b>สถานะ</b>:{' '}
                              {`${
                                order.evidence[0]?.status === PAYMENT_STATUS.IN_PROGRESS
                                  ? order.evidence[0]?.inProgress
                                  : order.evidence[0]?.status
                              }`}
                            </p>
                            <p>
                              <b>ประเภท</b>: {`${order.evidence[0]?.type}`}
                            </p>
                            <p>
                              <b>จำนวนเงินที่ระบบอ่านได้</b>: {`${order.evidence[0]?.amount}`} บาท
                            </p>
                            <p>
                              <b>รายละเอียด</b>: {`${order.evidence[0]?.detail.remark}`}
                            </p>
                            <p>
                              <b>อัปโหลดเมื่อเวลา</b>: {new Date(order.evidence[0]?.createdAt).toLocaleString('TH-th')}{' '}
                              น.
                            </p>
                            <p>
                              <b>ตรวจสอบเมื่อเวลา</b>:{' '}
                              {order.evidence[0].updatedAt !== UNASSIGNED_TIME &&
                                `${new Date(order.evidence[0]?.updatedAt).toLocaleString('TH-th')} น.`}{' '}
                            </p>
                            {order.evidence[0]?.solvedBy ? (
                              <div>
                                <hr />
                                <h4>ข้อมูลรายละเอียดการจัดสลิป Slip โดย Admin</h4>
                                <hr />
                                <p>
                                  <b>ชื่อผู้ตรวจสอบ</b>: {order.evidence[0].detail.solvedBy.userName}
                                </p>
                                <p>
                                  <b>ผลการตรวจสอบ</b>: {order.evidence[0].detail.remark}
                                </p>
                                <p>
                                  <b>ตรวจสอบเมื่อเวลา</b>:{' '}
                                  {order.evidence[0].updatedAt !== UNASSIGNED_TIME &&
                                    `${new Date(order.evidence[0]?.updatedAt).toLocaleString('TH-th')} น.`}{' '}
                                </p>
                              </div>
                            ) : null}
                            {order.status !== 'SUCCESS' &&
                            order.status !== 'CANCEL' &&
                            order.evidence[0].status === 'REJECT' ? (
                              <div className="m-3">
                                <button
                                  className="btn btn-info m-1"
                                  style={{ width: '335px' }}
                                  onClick={() => {
                                    const popId = order.evidence[0].id
                                    const qrText = order.evidence[0].qrText
                                    const imageURL = order.evidence[0].imageURL
                                    readQRCodeThisSlip(imageURL, popId, qrText)
                                  }}
                                >
                                  อ่านบาร์โค้ด QR สลิปใหม่{' '}
                                </button>
                              </div>
                            ) : null}
                            {order.status !== 'SUCCESS' &&
                            order.status !== 'CANCEL' &&
                            order.evidence?.[0].inProgress === 'BAD_SLIP' ? (
                              <div className="m-3">
                                <hr />
                                <div className="row">
                                  <div className="col-2 mt-2">รหัสอ้างอิง</div>
                                  <input
                                    className="form-control form-control-sm col-9"
                                    type="text"
                                    onChange={handleOnChangeSlipRef}
                                    placeholder="ระบุรหัสอ้างอิงที่เห็นจาก Slip หลังจากตรวจสอบ"
                                    id="refNoAdminReadSlip"
                                    style={{
                                      padding: '0 8px',
                                      height: '35px',
                                      color: '#000',
                                    }}
                                  />
                                  <div className="col-2 mt-2">จำนวนเงิน</div>
                                  <input
                                    className="form-control form-control-sm col-9"
                                    id="amoutAdminReadSlip"
                                    onChange={handleOnChangeMoneyAmount}
                                    placeholder="ระบุจำนวนเงินที่เห็นจาก Slip หลังจากตรวจสอบ"
                                    type="number"
                                    style={{
                                      marginTop: '10px',
                                      padding: '0 8px',
                                      height: '35px',
                                      color: '#000',
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                  />
                                  <button
                                    className="btn btn-success mt-3 ml-3 col-5"
                                    style={{ width: '120px' }}
                                    onClick={() =>
                                      approveBadSlip(
                                        order.evidence[0].id,
                                        null,
                                        order.user ? order.user.lineId : order.lineUid,
                                        `${order.refNo}`,
                                        order.id,
                                      )
                                    }
                                  >
                                    Approve Bad Slip
                                  </button>
                                  <button
                                    className="btn btn-danger mt-3 ml-3 col-5"
                                    style={{ width: '120px' }}
                                    onClick={() => rejectBadSlip(order.evidence[0].id, order.id)}
                                  >
                                    Reject Bad Slip{' '}
                                  </button>
                                  <button
                                    className="btn btn-info mt-3 ml-3 col-5"
                                    style={{ width: '120px' }}
                                    onClick={() =>
                                      readQRCodeThisSlip(
                                        order.evidence[0].imageURL,
                                        order.evidence[0].id,
                                        order.evidence[0].qrText,
                                      )
                                    }
                                  >
                                    อ่านบาร์โค้ด QR สลิปนี้{' '}
                                  </button>
                                </div>
                              </div>
                            ) : null}
                          </>
                        )}
                      </div>
                    </div>
                  </Col>
                ) : (
                  <Col>
                    {order.evidence?.includes('.jpg') ? (
                      <img
                        src={`${order.evidence}`}
                        style={{
                          maxWidth: '360px',
                          maxHeight: '600px',
                        }}
                        alt="slip"
                      />
                    ) : (
                      <div
                        style={{
                          marginBottom: '8px',
                          textAlign: 'center',
                          color: 'red',
                        }}
                      >
                        ไม่พบสลิปสำหรับคำสั่งซื้อ #{order.refNo}
                      </div>
                    )}
                  </Col>
                )}
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2 pb-2">
                    <h3>หลักฐานการโอนเงินเพิ่มเติม</h3>
                    {moreEvidencesSlip?.length > 0 && <small>* กรณีที่ลูกค้าแนบสลิปเพิ่มเติม </small>}
                  </div>
                </Col>
              </Row>
              <Row>
                {moreEvidencesSlip.length > 0 ? (
                  <Col>
                    {moreEvidencesSlip.map((item, index) => (
                      <div key={uuid.v4()} className="row mt-2 mb-2 border-bottom">
                        <div
                          className="col-5 mb-3"
                          style={{
                            justifyContent: 'center',
                            display: 'flex',
                            width: '100%',
                          }}
                        >
                          {item.imageURL !== '' ? (
                            <>
                              <img
                                src={item.imageURL}
                                style={{
                                  maxWidth: '360px',
                                  maxHeight: '600px',
                                }}
                                alt="slip"
                              />
                            </>
                          ) : (
                            'ไม่พบสลิป'
                          )}
                        </div>
                        <div className="col-7">
                          <h4>สถานะระบบตรวจสอบสลิปอัตโนมัติ</h4>
                          {order.evidence.length === 0 ? (
                            <>
                              {order.status === 'CONFIRMED' ? (
                                <>
                                  {checkTimeOutProcessBadSlips(new Date(item.createdAt)) ? (
                                    <>
                                      <hr />
                                      <p>
                                        <b className="text-danger">สถานะ: กำลังประมวลผล </b>
                                      </p>
                                      <p>
                                        <b>อัปโหลดเมื่อเวลา</b>: {new Date(item.createdAt).toLocaleString('TH-th')} น.
                                      </p>
                                    </>
                                  ) : (
                                    <>
                                      <p>
                                        <b className="text-danger">
                                          สถานะ: ระบบกำลังดำเนินการตรวจสอบสลิป ใช้เวลาประมาณ 5-15 นาที{' '}
                                        </b>
                                      </p>
                                      <p>
                                        <b>อัปโหลดเมื่อเวลา</b>: {new Date(item.createdAt).toLocaleString('TH-th')} น.
                                      </p>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {order.status === 'CANCEL' || order.status === 'SUCCESS' ? (
                                    <>
                                      <p className="text-info">
                                        สถานะ: ระบบได้เคลียร์สลิปออกจาก Queue
                                        แล้วเนื่องจากการดำเนินการของคำสั่งซื้อนี้สิ้นสุดแล้ว
                                      </p>
                                      <p>
                                        <b>อัปโหลดเมื่อเวลา</b>: {new Date(item.createdAt).toLocaleString('TH-th')} น.
                                      </p>
                                    </>
                                  ) : null}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <p>
                                <b>สถานะ</b>:{' '}
                                {item.status === PAYMENT_STATUS.IN_PROGRESS ? item.inProgress : item.status}
                              </p>
                              <p>
                                <b>จำนวนเงินที่ระบบอ่านได้</b>: {`${item.amount}`} บาท
                              </p>
                              <p>
                                <b>รายละเอียด</b>: {`${item.detail.remark}`}
                              </p>
                              <p>
                                <b>อัปโหลดเมื่อเวลา</b>: {new Date(item.createdAt).toLocaleString('TH-th')} น.
                              </p>
                              <p>
                                <b>ตรวจสอบเมื่อเวลา</b>:{' '}
                                {item.updatedAt !== UNASSIGNED_TIME &&
                                  `${new Date(item.updatedAt).toLocaleString('TH-th')} น.`}{' '}
                              </p>
                              {item.detail.solvedBy.userName ? (
                                <>
                                  <h4>ข้อมูลรายละเอียดการจัดสลิป Slip โดย Admin</h4>
                                  <p>
                                    <b>ชื่อผู้ตรวจสอบ</b>: {item.detail.solvedBy.username}
                                  </p>
                                  <p>
                                    <b>ผลการตรวจสอบ</b>: {item.detail.remark}
                                  </p>
                                  <p>
                                    <b>ตรวจสอบเมื่อเวลา</b>:{' '}
                                    {item.updatedAt !== UNASSIGNED_TIME &&
                                      `${new Date(item.updatedAt).toLocaleString('TH-th')} น.`}{' '}
                                  </p>
                                </>
                              ) : null}
                              {order.evidence !== undefined &&
                              order.status !== 'SUCCESS' &&
                              order.status !== 'CANCEL' &&
                              actionBadSlip === false &&
                              item?.inProgress === 'BAD_SLIP' ? (
                                <div className="m-3">
                                  <hr />
                                  <div className="row">
                                    <div className="col-2 mt-2">รหัสอ้างอิง</div>
                                    <input
                                      className="form-control form-control-sm col-9"
                                      type="text"
                                      onChange={handleOnChangeSlipRef}
                                      id={`refNoAdminReadSlip-${index}`}
                                      placeholder="ระบุรหัสอ้างอิงที่เห็นจาก Slip หลังจากตรวจสอบ"
                                      style={{
                                        padding: '0 8px',
                                        height: '35px',
                                        color: '#000',
                                      }}
                                    />
                                    <div className="col-2 mt-2">จำนวนเงิน</div>
                                    <input
                                      className="form-control form-control-sm col-9"
                                      id={`amoutAdminReadSlip-${index}`}
                                      onChange={handleOnChangeMoneyAmount}
                                      placeholder="ระบุจำนวนเงินที่เห็นจาก Slip หลังจากตรวจสอบ"
                                      type="number"
                                      style={{
                                        marginTop: '10px',
                                        padding: '0 8px',
                                        height: '35px',
                                        color: '#000',
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                    />
                                    <button
                                      className="btn btn-success mt-3 ml-3 col-5"
                                      style={{ width: '120px' }}
                                      onClick={() =>
                                        approveBadSlip(
                                          item.id,
                                          index,
                                          order.user ? order.user.lineId : order.lineUid,
                                          `${order.refNo}`,
                                          order.id,
                                        )
                                      }
                                    >
                                      Approve Bad Slip
                                    </button>
                                    <button
                                      className="btn btn-danger mt-3 ml-3 col-5"
                                      style={{ width: '120px' }}
                                      onClick={() => rejectBadSlip(item.id, order.id)}
                                    >
                                      Reject Bad Slip{' '}
                                    </button>
                                    <button
                                      className="btn btn-info mt-3 ml-3 col-5"
                                      style={{ width: '120px' }}
                                      onClick={() => readQRCodeThisSlip(item.imageURL, item.id, item.qrText)}
                                    >
                                      อ่านบาร์โค้ด QR สลิปนี้{' '}
                                    </button>
                                  </div>
                                </div>
                              ) : null}
                              {order.status !== 'SUCCESS' && order.status !== 'CANCEL' && item.status === 'REJECTED' ? (
                                <div className="m-3">
                                  <hr />
                                  <button
                                    className="btn btn-info m-1"
                                    style={{ width: '335px' }}
                                    onClick={() =>
                                      tickerLineNotify(
                                        order.user ? order.user.lineId : order.lineUid,
                                        'SLIP-INCORRECT',
                                        `${order.refNo}`,
                                        order.totalPrice,
                                        item.id,
                                      )
                                    }
                                  >
                                    แจ้งเตือนลูกค้าว่าพบสลิปที่แนบมาไม่ถูกต้อง{' '}
                                  </button>
                                  <button
                                    className="btn btn-info m-1"
                                    style={{ width: '335px' }}
                                    onClick={() =>
                                      tickerLineNotify(
                                        order.user ? order.user.lineId : order.lineUid,
                                        'INCOMPLETE-PAYMENT',
                                        `${order.orderNo}`,
                                        (order.totalPrice - order.paidAmount) * -1,
                                        item.id,
                                      )
                                    }
                                  >
                                    แจ้งเตือนลูกค้ายอดค้างชำระล่าสุด
                                  </button>
                                  <button
                                    className="btn btn-info m-1"
                                    style={{ width: '335px' }}
                                    onClick={() => {
                                      readQRCodeThisSlip(item.imageURL, item.id, item.qrText)
                                    }}
                                  >
                                    อ่านบาร์โค้ด QR สลิปใหม่{' '}
                                  </button>
                                </div>
                              ) : null}
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </Col>
                ) : (
                  <Col>
                    <div style={{ marginBottom: '8px', textAlign: 'center' }}>
                      <small style={{ color: 'red' }}>ไม่พบหลักฐานการโอนเงินเพิ่มเติม #{order.refNo}</small>
                    </div>
                  </Col>
                )}
              </Row>

              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2">
                    <h3>
                      รายละเอียดการสั่งซื้อ{' '}
                      {orderType === ORDER_ITEM_TYPE.LOTTERY ? (
                        <span style={{ fontSize: '20px' }} className="text-info">
                          (ลอตเตอรี่ {order.totalItem} ใบ)
                        </span>
                      ) : (
                        <span style={{ fontSize: '20px' }} className="text-danger">
                          (กล่องสุ่ม)
                        </span>
                      )}
                    </h3>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <OrderItemsDataTable order={order} boxesInfo={order.boxesInfo} orderType={orderType} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2">
                    <h3>ยอดซื้ออื่นในรอบนี้</h3>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  {orderOther?.length >= 1 ? (
                    <OrderUserList
                      key={uuid.v4()}
                      orders={orderOther?.filter((s) => s.orderNo !== order.orderNo && s.roundDate === order.roundDate)}
                      fetchMoreEvidencesSlip={fetchMoreEvidencesSlip}
                      moreEvidencesSlip={moreEvidencesSlip}
                    />
                  ) : (
                    <div
                      style={{
                        marginBottom: '8px',
                        textAlign: 'center',
                        color: 'red',
                      }}
                    >
                      ไม่พบคำสั่งซื้ออื่นในรอบนี้
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  )
}
